import { createFileRoute } from "@tanstack/react-router";
import { IndustriPage, industriHead } from "@/pages/IndustriPage";

export const Route = createFileRoute("/de/branchen/industrie-produktion")({
  head: () => industriHead("de"),
  component: () => <IndustriPage locale="de" />,
});
